import { defineStore } from 'pinia';

export const useNotification = defineStore('notification', {
    state: () => ({
        message: {}
    }),
    actions: {
        notify(data) {
            this.message = data;
        }
    }
})